import { Amplify } from 'aws-amplify';
import {
  signIn,
  signOut,
  signUp,
  confirmSignUp,
  getCurrentUser,
  fetchAuthSession,
  fetchUserAttributes,
  resetPassword,
  confirmResetPassword,
} from 'aws-amplify/auth';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env['VITE_COGNITO_USER_POOL_ID'] as string,
      userPoolClientId: import.meta.env['VITE_COGNITO_CLIENT_ID'] as string,
    },
  },
});

export async function getAccessToken(): Promise<string> {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString();
  if (!token) throw new Error('No access token available');
  return token;
}

export async function login(email: string, password: string) {
  return signIn({ username: email, password });
}

export async function logout() {
  return signOut();
}

export async function register(email: string, password: string, displayName: string) {
  return signUp({
    username: email,
    password,
    options: { userAttributes: { email, name: displayName } },
  });
}

export async function confirmRegistration(email: string, code: string) {
  return confirmSignUp({ username: email, confirmationCode: code });
}

export async function currentUser() {
  try {
    const user = await getCurrentUser();
    const attrs = await fetchUserAttributes();
    return { ...user, email: attrs.email ?? user.username, username: attrs.name ?? attrs.email ?? user.username };
  } catch {
    return null;
  }
}

export async function requestPasswordReset(email: string) {
  return resetPassword({ username: email });
}

export async function confirmPasswordReset(email: string, code: string, newPassword: string) {
  return confirmResetPassword({ username: email, confirmationCode: code, newPassword });
}
